// Sunset policy for the legacy portal (cloud.larasoft.global). Frontend-only; the backend is unchanged.
export const NEW_PORTAL_URL = 'https://larasoft.global/portal';
export const SHUTDOWN_DATE = '31 December 2026';
export const MYAPP_URL = 'https://larasoft.global/products/myapp';
export const CONTACT_EMAIL = 'allan@larasoft.global';
export const CONTACT_PHONE = '+27824578390';

// Organisations that still use the Excel Connector here. Matched case-insensitively against the organisation's CompanyName.
export const EXCEL_ORG_MATCHERS = ['entersekt', 'little green pharma'];

export const isExcelConnectorType = (type?: string): boolean => (type ?? '').toLowerCase() === 'excel';

export const orgStillUsesExcel = (companyName?: string): boolean => {
  const name = (companyName ?? '').trim().replace(/\s+/g, ' ').toLowerCase();
  return EXCEL_ORG_MATCHERS.some((m) => name.includes(m));
};

export const TABLE_CREATION_BLOCKED_MESSAGE = 'New tables can no longer be created on this site. Existing tables can still be edited.';
